


// import React, { useEffect, useState, useContext } from 'react';
// import { Link } from 'react-router-dom';
// import { Carousel } from 'react-bootstrap';
// import Rightcontainer from '../Components/Rightcontainer';
// import Downloadbutton from '../Components/Downloadbutton';
// import DownloadPopup from '../Components/DownloadPopup';
// import Header from '../Components/Header';
// import { LanguageContext } from '../Components/LanguageContext';
// import { Sparkles, MessageCircle, Gamepad2, Radio, Play, Headphones, Award ,Zap ,Gift} from 'lucide-react';
// import 'bootstrap/dist/css/bootstrap.min.css';
// // import './Landing.css';

// export default function Landing({ userAllData }) {
//   const [showDownloadPopup, setShowDownloadPopup] = useState(true);
//   const { language } = useContext(LanguageContext);

//   const siteSettingRaw = localStorage.getItem('sitSetting');
//   let siteSetting = {};
//   try {
//     siteSetting = siteSettingRaw && siteSettingRaw !== 'undefined' ? JSON.parse(siteSettingRaw) : {};
//   } catch (e) {
//     siteSetting = {};
//   }

//   const translations = {
//     hi: { Tournaments: 'प्रतियोगिता', playNow: 'अभी खेलें', support: 'सपोर्ट' },
//     en: { Tournaments: 'Tournaments', playNow: 'Play Now', support: 'Support' },
//   };

//   const t = translations[language] || translations.en;

//   return (
//     <>
//       {/* {showDownloadPopup && <DownloadPopup onClose={() => setShowDownloadPopup(false)} />} */}

//       <div className="landing-page-wrapper leftContainer mb_space mt-5 pt-5">
//         {/* Background Ambient Mesh Lights */}
//         <div className="landing-ambient glow-1"></div>
//         <div className="landing-ambient glow-2"></div>
//         <div className="landing-ambient glow-3"></div>

//         <div className="landing-main-container">

//           {/* ANNOUNCEMENT MESSAGE BANNER */}
//           {siteSetting?.site_message && (
//             <div className="announcement-card animate-fade-down">
//               <div className="announcement-content">
//                 <Sparkles className="sparkle-icon spin-sparkle" size={18} />
//                 <span>{siteSetting.site_message}</span>
//               </div>
//             </div>
//           )}

// {/* SITE MSG KE NICHE WALI SECOND MARQUEE */}
//           <div 
//             style={{
//               background: 'linear-gradient(90deg, #111827 0%, #1f2937 50%, #111827 100%)',
//               borderLeft: '4px solid #10b981',
//               borderRadius: '8px',
//               padding: '17px 12px',
//               marginTop: '10px',
//               marginBottom: '15px',
//               boxShadow: '0 4px 12px rgba(16, 185, 129, 0.15)',
//               display: 'flex',
//               alignItems: 'center',
//               overflow: 'hidden'
//             }}
//           >
//             <div style={{ display: 'flex', alignItems: 'center', marginRight: '10px', color: '#10b981', fontWeight: 'bold' }}>
//               <Zap size={16} style={{ marginRight: '4px' }} />
//               <span style={{ fontSize: '12px', letterSpacing: '0.5px', textTransform: 'uppercase' }}>OFFER</span>
//             </div>
//             {/* Standard HTML Marquee Tag */}
//             <marquee 
//               scrollamount="6" 
//               style={{ color: '#ec4899', fontWeight: '700', fontSize: '14px', letterSpacing: '0.5px' }}
//             >
//               🔥 SPECIAL 3% REFER COMISSION AND 2% COMMISSION DE RHE HAI 🔥
//             </marquee>
//           </div>
//           {/* GAMES SELECTION GRID */}
//           <section className="games-section-wrapper">
//             <div className="games-section-header">
//               <div className="header-left">
//                 <div className="section-icon-box">
//                   <Gamepad2 size={22} className="title-icon" />
//                 </div>
//                 <h3 className="section-title">Featured Games</h3>
//               </div>
//               <div className="live-count-badge">
//                 <Radio size={12} className="pulse-radio" />
//                 <span>ACTIVE LOBBIES</span>
//               </div>
//             </div>

//             {/* SIDE-BY-SIDE 2-COLUMN ROW (6-6 SPLIT) */}
//             <div className="games-grid-container two-cols">
//               {/* LUDO CLASSIC MANUAL CARD */}
//               <Link to="/Homepage/ludoClassicManual" className="game-card-link">
//                 <div className="game-card-box">
//                   <div className="card-top-bar">
//                     <div className="live-status-pill">
//                       <Radio size={12} className="pulse-radio" />
//                       <span>LIVE</span>
//                     </div>
//                     <span className="game-badge-mini">
//                       <Award size={12} /> Classic
//                     </span>
//                   </div>

//                   <div className="game-card-img-wrap">
//                     <img
//                       src="./mainimage/ludoclassic.png"
//                       alt="Ludo Classic"
//                       className="game-cover-img"
//                     />
//                   </div>


//                 </div>
//               </Link>

//               {/* LUDO WHATSAPP SUPPORT CARD */}
//               {siteSetting?.whatsappSupport && (
//                 <a
//                   href={siteSetting.whatsappSupport}
//                   target="_blank"
//                   rel="noreferrer"
//                   className="game-card-link"
//                 >
//                   <div className="game-card-box support-card-variant">
//                     <div className="card-top-bar">
//                       <div className="live-status-pill red-live">
//                         <Radio size={12} className="pulse-radio" />
//                         <span>LIVE</span>
//                       </div>
//                       <span className="game-badge-mini gold">
//                         <Headphones size={12} /> 24/7 Help
//                       </span>
//                     </div>

//                     <div className="game-card-img-wrap">
//                       <img
//                         src="./mainimage/ludosupport.png"
//                         alt="Ludo Support"
//                         className="game-cover-img"
//                       />
//                     </div>

//                     <div className="card-hover-overlay">
//                       <span className="play-btn-pill gold">
//                         <Headphones size={14} />
//                         {t.support}
//                       </span>
//                     </div>
//                   </div>
//                 </a>
//               )}
//             </div>
//           </section>
//           {/* 3. EXPLORE OUR SERVICES Section */}
//           {/* <div className="section-divider d-flex align-items-center my-4">
//             <div className="flex-grow-1 border-top "></div>
//             <span className="mx-3 font-weight-bold" style={{ letterSpacing: '1px', fontSize: '18px', color: '#000' }}>
//               EXPLORE OUR SERVICES
//             </span>
//             <div className="flex-grow-1 border-top bordersecondarys"></div>
//           </div> */}

//           {/* 3. EXPLORE OUR SERVICES KI JAGAH HIGH-HIGHLIGHTED OFFER MARQUEE */}
//           <div 
//             style={{
//               margin: '3px 0 15px 0',
//               padding: '17px 15px',
//               background: 'linear-gradient(135deg, #0f172a 0%, #1e1b4b 50%, #311042 100%)',
//               borderRadius: '12px',
//               border: '1px solid #818cf8',
//               boxShadow: '0 0 15px rgba(129, 140, 248, 0.3)',
//               display: 'flex',
//               alignItems: 'center',
//               overflow: 'hidden'
//             }}
//           >
//             <div 
//               style={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 background: 'linear-gradient(45deg, #f59e0b, #ef4444)',
//                 padding: '4px 10px',
//                 borderRadius: '6px',
//                 color: '#fff',
//                 fontWeight: '800',
//                 fontSize: '12px',
//                 marginRight: '12px',
//                 whiteSpace: 'nowrap',
//                 boxShadow: '0 2px 8px rgba(245, 158, 11, 0.4)'
//               }}
//             >
//               <Gift size={16} style={{ marginRight: '5px' }} />
//               MEGA OFFER
//             </div>

//             <marquee 
//               scrollamount="7"
//               style={{
//                 color: '#facc15',
//                 fontSize: '15px',
//                 fontWeight: '800',
//                 letterSpacing: '1px',
//                 textTransform: 'uppercase'
//               }}
//             >
//               🎁 BUMPER REFERRAL REWARD: JO USERS AGAR APNE REFREAL SE 50 PLUS USERS ADD KRTA HAI USKO 11K KA BONUS DIA JAYEGA! 🎁
//             </marquee>
//           </div>

//           {/* Services Banner */}
//           <div className='services-banner-container mb-4 shadow-sm'>
//             <img
//               src='/banneripl.png'
//               className='w-100 rounded'
//               alt="Services"
//               style={{ display: 'block' }}
//             />
//           </div>
//           {/* DOWNLOAD APP BUTTON SECTION */}
//           <div className="download-button-wrapper">
//             <Downloadbutton />
//           </div>

//         </div>
//       </div>

//       {/* WHATSAPP SUPPORT FLOATING ACTION */}
//       {siteSetting?.whatsappSupport && (
//         <div className="floating-social-btn whatsapp-floating">
//           <a href={siteSetting.whatsappSupport} target="_blank" rel="noreferrer">
//             {/* Floating whatsapp icon display */}
//           </a>
//         </div>
//       )}

//       {/* RIGHT SIDEBAR ON DESKTOP */}
//       <div className="rightContainer">
//         <Rightcontainer />
//       </div>
//     </>
//   );
// }


import React, { useEffect, useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { Carousel } from 'react-bootstrap';
import Rightcontainer from '../Components/Rightcontainer';
import Downloadbutton from '../Components/Downloadbutton';
import DownloadPopup from '../Components/DownloadPopup';
import Header from '../Components/Header';
import { LanguageContext } from '../Components/LanguageContext';
import { Sparkles, MessageCircle, Gamepad2, Radio, Play, Headphones, Award, Zap, Gift, Bot } from 'lucide-react';
import 'bootstrap/dist/css/bootstrap.min.css';
// import './Landing.css';

export default function Landing({ userAllData }) {
  const [showDownloadPopup, setShowDownloadPopup] = useState(true);
  const { language } = useContext(LanguageContext);

  const siteSettingRaw = localStorage.getItem('sitSetting');
  let siteSetting = {};
  try {
    siteSetting = siteSettingRaw && siteSettingRaw !== 'undefined' ? JSON.parse(siteSettingRaw) : {};
  } catch (e) {
    siteSetting = {};
  }

  const translations = {
    hi: { Tournaments: 'प्रतियोगिता', playNow: 'अभी खेलें', support: 'सपोर्ट' },
    en: { Tournaments: 'Tournaments', playNow: 'Play Now', support: 'Support' },
  };

  const t = translations[language] || translations.en;
  const [offerBlink, setOfferBlink] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setOfferBlink((prev) => !prev);
    }, 700);

    return () => clearInterval(interval);
  }, []);
  return (
    <>
      {/* {showDownloadPopup && <DownloadPopup onClose={() => setShowDownloadPopup(false)} />} */}

      <div className="landing-page-wrapper leftContainer mb_space mt-5 pt-5">
        {/* Background Ambient Mesh Lights */}
        <div className="landing-ambient glow-1"></div>
        <div className="landing-ambient glow-2"></div>
        <div className="landing-ambient glow-3"></div>

        <div className="landing-main-container">

          {/* ANNOUNCEMENT MESSAGE BANNER */}
          {siteSetting?.site_message && (
            <div className="announcement-card animate-fade-down">
              <div className="announcement-content">
                <Sparkles className="sparkle-icon spin-sparkle" size={18} />
                <span>{siteSetting.site_message}</span>
              </div>
            </div>
          )}

          {/* SITE MSG KE NICHE WALI SECOND MARQUEE */}
          <div
            style={{
              background: offerBlink
                ? "linear-gradient(135deg, #111827 0%, #263449 50%, #111827 100%)"
                : "linear-gradient(135deg, #111827 0%, #1e293b 50%, #111827 100%)",

              border: offerBlink
                ? "1px solid rgba(16, 185, 129, 0.75)"
                : "1px solid rgba(16, 185, 129, 0.35)",

              borderLeft: offerBlink
                ? "4px solid #22c55e"
                : "4px solid #10b981",

              borderRadius: "10px",
              padding: "13px 14px",
              marginTop: "10px",
              marginBottom: "15px",

              boxShadow: offerBlink
                ? "0 0 20px rgba(16, 185, 129, 0.45)"
                : "0 5px 18px rgba(0, 0, 0, 0.25)",

              display: "flex",
              alignItems: "center",
              gap: "12px",

              opacity: offerBlink ? 1 : 0.82,

              transform: offerBlink
                ? "scale(1)"
                : "scale(0.99)",

              transition: "all 0.4s ease",
            }}
          >
            {/* OFFER Badge */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",

                color: offerBlink ? "#ff3b30" : "#c01a1a",

                fontWeight: "800",
                fontSize: "11px",
                letterSpacing: "0.7px",
                whiteSpace: "nowrap",

                padding: "6px 9px",
                borderRadius: "6px",

                background: offerBlink
                  ? "rgba(255, 59, 48, 0.18)"
                  : "rgba(255, 59, 48, 0.08)",

                border: offerBlink
                  ? "1px solid rgba(255, 59, 48, 0.55)"
                  : "1px solid rgba(255, 59, 48, 0.25)",

                boxShadow: offerBlink
                  ? "0 0 12px rgba(255, 59, 48, 0.35)"
                  : "none",

                transition: "all 0.4s ease",
              }}
            >
              <Zap
                size={15}
                style={{
                  opacity: offerBlink ? 1 : 0.7,
                  transition: "all 0.4s ease",
                }}
              />

              <span>OFFER</span>
            </div>

            {/* FULL BLINK MESSAGE */}
            <div
              style={{
                color: offerBlink ? "#ffffff" : "#d1d5db",
                fontWeight: "700",
                fontSize: "13px",
                letterSpacing: "0.2px",
                lineHeight: "1.5",

                textShadow: offerBlink
                  ? "0 0 8px rgba(255,255,255,0.25)"
                  : "none",

                transition: "all 0.4s ease",
              }}
            >
              🔥 SPECIAL{" "}
              <span
                style={{
                  color: offerBlink ? "#ffd166" : "#f59e0b",
                  fontWeight: "900",
                  transition: "all 0.4s ease",
                }}
              >
                4% REFER COMMISSION
              </span>{" "}
              AND{" "}
              <span
                style={{
                  color: offerBlink ? "#ff5ca8" : "#ec4899",
                  fontWeight: "900",
                  transition: "all 0.4s ease",
                }}
              >
                2% COMMISSION
              </span>{" "}
              DE RAHE HAI 🔥
            </div>
          </div>

          {/* GAMES SELECTION GRID */}
          <section className="games-section-wrapper">
            <div className="games-section-header">
              <div className="header-left">
                <div className="section-icon-box">
                  <Gamepad2 size={22} className="title-icon" />
                </div>
                <h3 className="section-title">Featured Games</h3>
              </div>
              <div className="live-count-badge">
                <Radio size={12} className="pulse-radio" />
                <span>ACTIVE LOBBIES</span>
              </div>
            </div>

            {/* SIDE-BY-SIDE 2-COLUMN ROW (6-6 SPLIT) */}
            <div className="games-grid-container two-cols">
              {/* LUDO CLASSIC MANUAL CARD */}
              <Link to="/Homepage/ludoClassicManual" className="game-card-link">
                <div className="game-card-box">
                  <div className="card-top-bar">
                    <div className="live-status-pill">
                      <Radio size={12} className="pulse-radio" />
                      <span>LIVE</span>
                    </div>
                    <span className="game-badge-mini">
                      <Award size={12} /> Classic
                    </span>
                  </div>

                  <div className="game-card-img-wrap">
                    <img
                      src="./mainimage/ludoclassic.png"
                      alt="Ludo Classic"
                      className="game-cover-img"
                    />
                  </div>
                </div>
              </Link>

              {/* LUDO WHATSAPP SUPPORT CARD */}
              {siteSetting?.whatsappSupport && (
                <a
                  href={siteSetting.whatsappSupport}
                  target="_blank"
                  rel="noreferrer"
                  className="game-card-link"
                >
                  <div className="game-card-box support-card-variant">
                    <div className="card-top-bar">
                      <div className="live-status-pill red-live">
                        <Radio size={12} className="pulse-radio" />
                        <span>LIVE</span>
                      </div>
                      <span className="game-badge-mini gold">
                        <Headphones size={12} /> 24/7 Help
                      </span>
                    </div>

                    <div className="game-card-img-wrap">
                      <img
                        src="./mainimage/ludosupport.png"
                        alt="Ludo Support"
                        className="game-cover-img"
                      />
                    </div>

                    <div className="card-hover-overlay">
                      <span className="play-btn-pill gold">
                        <Headphones size={14} />
                        {t.support}
                      </span>
                    </div>
                  </div>
                </a>
              )}
            </div>
          </section>

          {/* 3. EXPLORE OUR SERVICES KI JAGAH HIGH-HIGHLIGHTED OFFER MARQUEE */}
          <div
            style={{
              margin: '3px 0 15px 0',
              padding: '17px 15px',
              background: 'linear-gradient(135deg, #0f172a 0%, #1e1b4b 50%, #311042 100%)',
              borderRadius: '12px',
              border: '1px solid #818cf8',
              boxShadow: '0 0 15px rgba(129, 140, 248, 0.3)',
              display: 'flex',
              alignItems: 'center',
              overflow: 'hidden'
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                background: 'linear-gradient(45deg, #f59e0b, #ef4444)',
                padding: '4px 10px',
                borderRadius: '6px',
                color: '#fff',
                fontWeight: '800',
                fontSize: '12px',
                marginRight: '12px',
                whiteSpace: 'nowrap',
                boxShadow: '0 2px 8px rgba(245, 158, 11, 0.4)'
              }}
            >
              <Gift size={16} style={{ marginRight: '5px' }} />
              MEGA OFFER
            </div>

            <marquee
              scrollamount="7"
              style={{
                color: '#facc15',
                fontSize: '15px',
                fontWeight: '800',
                letterSpacing: '1px',
                textTransform: 'uppercase'
              }}
            >
              🎁 BUMPER REFERRAL REWARD: JO USERS AGAR APNE REFREAL SE 50 PLUS USERS ADD KRTA HAI USKO 11K KA BONUS DIA JAYEGA! 🎁
            </marquee>
          </div>

          {/* Services Banner */}
          <div className='services-banner-container mb-4 shadow-sm'>
            <img
              src='/banneripl.png'
              className='w-100 rounded'
              alt="Services"
              style={{ display: 'block' }}
            />
          </div>

          {/* DOWNLOAD APP BUTTON SECTION */}
          <div className="download-button-wrapper">
            <Downloadbutton />
          </div>

        </div>
      </div>

      {/* FLOATING BOT AVATAR SUPPORT BUTTON (POSITION UPDATED ABOVE FOOTER BAR) */}
      {/* FLOATING BOT AVATAR SUPPORT BUTTON */}
      <Link
        to="/support-chat"
        style={{
          position: 'fixed',
          bottom: '80px', // Bottom Footer Navigation bar ke upar
          right: '18px',
          zIndex: 99999,
          display: 'flex',
          alignItems: 'center',
          textDecoration: 'none'
        }}
      >
        {/* Pulsing Keyframe Animations */}
        <style>
          {`
      @keyframes botPulse {
        0% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7); }
        70% { box-shadow: 0 0 0 15px rgba(37, 211, 102, 0); }
        100% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0); }
      }
      @keyframes botBounce {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(-5px); }
      }
    `}
        </style>

        {/* Help Badge */}
        <div
          style={{
            background: '#1e293b',
            color: '#ffffff',
            padding: '6px 12px',
            borderRadius: '20px 0 0 20px',
            fontSize: '11px',
            fontWeight: 'bold',
            marginRight: '-8px',
            boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
            border: '1px solid #25D366',
            borderRight: 'none',
            letterSpacing: '0.5px'
          }}
        >
          Help 24/7
        </div>

        {/* Bot Floating Circle */}
        <div
          style={{
            width: '52px',
            height: '52px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #25D366 0%, #128C7E 100%)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: '#ffffff',
            cursor: 'pointer',
            animation: 'botPulse 2s infinite, botBounce 3s ease-in-out infinite',
            position: 'relative',
            boxShadow: '0 6px 16px rgba(0, 0, 0, 0.3)',
            transition: 'transform 0.2s ease-in-out'
          }}
          onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.08)')}
          onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
        >
          <Bot size={28} />

          {/* Green Online Dot */}
          <span
            style={{
              position: 'absolute',
              top: '2px',
              right: '2px',
              width: '12px',
              height: '12px',
              backgroundColor: '#22c55e',
              borderRadius: '50%',
              border: '2px solid #ffffff'
            }}
          />
        </div>
      </Link>

      {/* RIGHT SIDEBAR ON DESKTOP */}
      <div className="rightContainer">
        <Rightcontainer />
      </div>
    </>
  );
}